import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToggleFiltersOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 11.6667V6.66667H1.66667V10H5V11.6667H0ZM10 5V1.66667H6.66667V0H11.6667V5H10Z",
		fill: "#118AB2"
	})
});
export default SvgToggleFiltersOpen;
